import { useEffect, useState } from "react";
import { api } from "@/api";
import { toast } from "sonner";
import { Palette } from "lucide-react";
import { PALETTE } from "@/components/IncidentMaps";

// Beheer: give each drawing colour a meaning. Shown as a legend on all maps.
export function ColorLegendEditor({ canWrite }) {
  const [legend, setLegend] = useState({});
  const [saving, setSaving] = useState(false);
  const [ready, setReady] = useState(false);

  useEffect(() => { api.get("/settings/color-legend").then(({ data }) => { setLegend(data.legend || {}); setReady(true); }).catch(() => setReady(true)); }, []);

  const save = async () => {
    setSaving(true);
    try { await api.put("/settings/color-legend", { legend }); toast.success("Kleurlegenda opgeslagen"); }
    catch (e) { toast.error("Opslaan mislukt"); }
    finally { setSaving(false); }
  };

  if (!ready) return null;
  return (
    <div className="mt-4 rounded-2xl border border-slate-200 bg-white p-4 shadow-sm" data-testid="color-legend-editor">
      <div className="mb-1 flex items-center gap-2 text-sm font-bold text-slate-900"><Palette style={{ width: 16, height: 16 }} className="text-slate-500" /> Kleurbetekenis (legenda)</div>
      <p className="mb-3 text-xs text-slate-500">Geef elke tekenkleur een betekenis. De legenda verschijnt op alle kaarten (incident, voertuig-app, rapport). Leeg = niet in de legenda.</p>
      <div className="grid gap-2 sm:grid-cols-2">
        {PALETTE.map((p) => (
          <div key={p.c} className="flex items-center gap-2 rounded-xl border border-slate-200 bg-slate-50 px-2.5 py-2">
            <span className="h-5 w-5 shrink-0 rounded-full border-2 border-white shadow" style={{ backgroundColor: p.c }} />
            <input data-testid={`legend-input-${p.c}`} disabled={!canWrite} value={legend[p.c] || ""} onChange={(e) => setLegend((l) => ({ ...l, [p.c]: e.target.value }))} placeholder={p.label} className="w-full rounded-lg border border-slate-200 bg-white px-2.5 py-1.5 text-sm outline-none focus:border-blue-500" />
          </div>
        ))}
      </div>
      {canWrite && <button data-testid="color-legend-save" onClick={save} disabled={saving} className="mt-3 rounded-lg bg-slate-900 px-4 py-2 text-sm font-semibold text-white hover:bg-slate-700 disabled:opacity-60">Opslaan</button>}
    </div>
  );
}
